import React, {PureComponent} from 'react';
import { Button, Carousel, Checkbox, DatePicker, Form, Input, Radio, Select, Row, Col} from 'antd';
import Dimio, {FormComponent } from 'dimio';

import config from '../config/config';

const {Option} = Select;
const {fields} = config.purchase;

class QuoteFlight extends FormComponent{
  constructor(props) {
    super(props);

    this.onSelectCity = this.onSelectCity.bind(this);
  }

  onSelectCity(city){
    const {form} = this.props;
    form.setFieldsValue({flight_quote_out: city});
  }

  render() {
    const Field = this.Field;

    return (
      <div className='border rounded bg-white p-3 mb-3'>
        <div className='font-weight-bold mb-3'>出発地と帰着地を選択してください。</div>

        <div className='row gutter-10 align-self-stretch mb-4'>
          <div className="col-12">
            <Field {...fields.flight_quote_in}>
            <Select className='d-block' onChange={this.onSelectCity}>
              {fields.flight_quote_in.items.map(city => (
                <Option value={city.label} key={city.key}>{city.label}</Option>
              ))}
            </Select>
            </Field>
          </div>
          {/*
          <div className="col-1 col-lg-1">
            <div className="d-flex justify-content-center align-items-center text-center h-100">
              <svg xmlns="http://www.w3.org/2000/svg" width="16px" viewBox="0 0 24 24">
                <path
                  d="M10.024 4h6.015l7.961 8-7.961 8h-6.015l7.961-8-7.961-8zm-10.024 16h6.015l7.961-8-7.961-8h-6.015l7.961 8-7.961 8z"/>
              </svg>
            </div>
          </div>
          <div className="col-12">
            <div
              className="d-flex justify-content-center align-items-center text-center border border-success text-success rounded h-100 font-weight-bold">
              <div className="">
                ウルル
              </div>
            </div>
          </div>
          */}
        </div>

        <div className='row gutter-10 align-self-stretch mb-4'>
        {/*
          <div className="col-12">
            <div
              className="d-flex justify-content-center align-items-center text-center border border-success text-success rounded h-100 font-weight-bold">
              <div className="">
                ウルル
              </div>
            </div>
          </div>
          <div className="col-1 col-lg-1">
            <div className="d-flex justify-content-center align-items-center text-center h-100">
              <svg xmlns="http://www.w3.org/2000/svg" width="16px" viewBox="0 0 24 24">
                <path
                  d="M10.024 4h6.015l7.961 8-7.961 8h-6.015l7.961-8-7.961-8zm-10.024 16h6.015l7.961-8-7.961-8h-6.015l7.961 8-7.961 8z"/>
              </svg>
            </div>
          </div>
          */}
          <div className="col-12">
            <Field {...fields.flight_quote_out}>
              <Select>
                {fields.flight_quote_out.items.map(city => (
                  <Option value={city.label} key={city.key}>{city.label}</Option>
                ))}
              </Select>
            </Field>
          </div>
        </div>
      </div>
    )
  }
};

export default QuoteFlight;



// WEBPACK FOOTER //
// ./src/pages/purchase/components/QuoteFlight.js